import { observer } from 'mobx-react';
import { useMemo } from 'react';
import MulticheckActions from '../../../../../Multicheck/MulticheckActions';
import { MulticheckStore } from '../../../../../Multicheck/Store';
import ModalReactions from '../../../../Modal/ModalReactions';
import ModalStore from '../../../../Modal/Store';
import { InvitationResource } from '../Store/Types';
import DeactivateButton from './DeactivateButton';
import BulkEditInvitationsModal from './EditInvitations/Modal';
import BulkEditInvitationsStore from './EditInvitations/Store';
import ReactivateButton from './ReactivateButton';

interface Props {
  store: BulkEditInvitationsStore;
  multicheckStore: MulticheckStore<InvitationResource>;
}

function BulkActions({ store, multicheckStore }: Props) {
  const modalStore = useMemo(() => new ModalStore(), []);

  return (
    <>
      <MulticheckActions store={multicheckStore}>
        <DeactivateButton store={store} multicheckStore={multicheckStore} modalStore={modalStore} />
        <ReactivateButton store={store} multicheckStore={multicheckStore} modalStore={modalStore} />
      </MulticheckActions>
      <BulkEditInvitationsModal store={store} modalStore={modalStore} />
      <ModalReactions store={modalStore} />
    </>
  );
}

export default observer(BulkActions);
